export const editStyle = StyleSheet.create({
  weekDayCard: {
    flexDirection: 'row',
    justifyContent: 'space-between'}
})
